<template>
  <div class="page-publicList" :class="{ 'page-back': classId }">
    <div :class="{ 'page-width': classId }">
      <Breadcrumb :list="list" v-if="!classId" />
      <div class="publicList-title" v-if="!classId">
        <img :src="classifyIcon" :alt="classifyName" />
        <span>{{ classifyName }}</span>
      </div>
      <div class="publicList-content">
        <div class="list-box">
          <div
            v-for="(item, index) in publicList"
            :key="item.id + index"
            class="content-row"
            @click="hanleRow(item)"
          >
            <span class="row-point"></span>
            <div class="row-content">
              <span class="title">{{ item.infoName }}</span>
              <span class="time" v-if="item.publishTime">{{
                item.publishTime.slice(0, 10)
              }}</span>
            </div>
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleLimitChange"
            @current-change="handlePageChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { classList } from './assets'
import Breadcrumb from '../../components/breadcrumb.vue'
import * as API from '../../api/home/index'
export default {
  name: 'PublicInformationList',
  components: { Breadcrumb },
  props: {
    classId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    const { classifyId = 1 } = this.$route.query
    const { label, iconName } =
      classList.find((item) => item.value === Number(classifyId)) ?? {}
    return {
      classList,
      list: [
        {
          label,
          path: '/publicInformationList'
        }
      ],
      classifyName: label,
      classifyIcon: require(`../../assets/image/${iconName}`),
      total: 0,
      page: 1,
      limit: 10,
      publicList: []
    }
  },
  computed: {
    classifyId() {
      return this.classId || this.$route.query.classifyId
    }
  },
  created() {
    this.getPublicList()
  },
  methods: {
    async getPublicList() {
      try {
        const { page, limit, classifyId } = this
        const params = {
          page,
          limit,
          classifyId
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.publicList = records
          this.total = Number(total)
        }
      } catch (error) {}
    },
    handleLimitChange(limit) {
      this.page = 1
      this.limit = limit
      this.getPublicList()
    },
    handlePageChange(page) {
      this.page = page
      this.getPublicList()
    },
    hanleRow(row) {
      const { id } = row
      const { classifyId } = this
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId, id }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-back {
  background-color: #fff !important;
}
.page-publicList {
  padding: 28px 0 88px 0;
  background: #eef3ff;
  .page-width {
    width: 100% !important;
  }
  > div {
    width: 1300px;
    margin: 0 auto;
    background: #fff;
    padding-bottom: 20px;
    .publicList-title {
      width: 1240px;
      margin: 20px auto 30px;
      height: 54px;
      background: linear-gradient(90deg, #0751b5 0%, #507cf7 100%);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      > img {
        width: 24px;
        height: 24px;
        display: block;
        margin: 0 24px 0 20px;
      }
      > span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fffefe;
      }
    }
    .publicList-content {
      box-sizing: border-box;
      // width: 100%;
      margin: 0 30px;
      height: 620px;
      border: 2px solid #0753b6;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .list-box {
        width: 100%;
        flex: 1;
        overflow: auto;
        .content-row {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          position: relative;
          .row-point {
            position: absolute;
            top: 8px;
            width: 4px;
            height: 4px;
            background: #ff4e4e;
            border-radius: 50%;
            margin: 0 13px 0 23px;
          }
          .row-content {
            flex: 1;
            margin-right: 36px;
            border-bottom: 1px dashed #c6c6c6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 10px;
            padding-left: 36px;
            .title {
              flex: 1;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
            .time {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
            }
          }
        }
      }
      .pagination-box {
        padding: 10px;
      }
    }
  }
}
</style>
